import { LegalLayout, LegalSection } from "@/components/LegalLayout";

export default function Confidentialite() {
  return (
    <LegalLayout
      title="Politique de confidentialité"
      overline="Confidentialité"
      updatedAt="juin 2026"
      testId="privacy-page"
    >
      <LegalSection title="1. Qui sommes-nous">
        <p>
          LOGI SEO Booster (« l'Application », accessible à l'adresse{" "}
          <a href="https://seo.logitrak.ch" className="text-[#002FA7] hover:underline">seo.logitrak.ch</a>) est une
          plateforme d'optimisation SEO permettant d'auditer des sites web, de générer du contenu assisté par IA et de
          suivre les performances de recherche. Le responsable du traitement des données est l'éditeur de l'Application,
          joignable à l'adresse <a href="mailto:janou.info@gmail.com" className="text-[#002FA7] hover:underline">janou.info@gmail.com</a>.
        </p>
      </LegalSection>

      <LegalSection title="2. Données que nous collectons">
        <p>Dans le cadre de l'utilisation de l'Application, nous collectons :</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li><span className="font-medium text-slate-800">Données de compte</span> : adresse e-mail, nom, mot de passe (stocké sous forme hachée, jamais en clair).</li>
          <li><span className="font-medium text-slate-800">Données de sites</span> : URL des sites que vous ajoutez, résultats d'audits SEO, mots-clés suivis, contenus générés ou importés.</li>
          <li><span className="font-medium text-slate-800">Données d'utilisation</span> : historique des générations de contenu, quotas consommés, journaux techniques nécessaires au fonctionnement du service.</li>
          <li><span className="font-medium text-slate-800">Données Google Search Console</span> : uniquement si vous connectez volontairement votre compte Google (voir section 3).</li>
        </ul>
      </LegalSection>

      <LegalSection title="3. Données Google (Search Console)">
        <p>
          Si vous choisissez de connecter votre compte Google, l'Application accède en{" "}
          <span className="font-medium text-slate-800">lecture</span> à vos données Google Search Console
          (requêtes de recherche, pages, clics, impressions, positions) afin d'afficher vos performances SEO
          et de produire des recommandations.
        </p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Nous n'accédons qu'aux données strictement nécessaires aux fonctionnalités que vous utilisez.</li>
          <li>Vos jetons d'accès Google sont stockés chiffrés et ne sont jamais partagés avec des tiers.</li>
          <li>Nous ne vendons jamais vos données Google et ne les utilisons pas à des fins publicitaires.</li>
          <li>
            Vous pouvez révoquer l'accès à tout moment depuis l'Application (bouton « Déconnecter Google ») ou depuis{" "}
            <a href="https://myaccount.google.com/permissions" target="_blank" rel="noreferrer" className="text-[#002FA7] hover:underline">
              les paramètres de sécurité de votre compte Google
            </a>.
          </li>
        </ul>
        <p>
          L'utilisation des informations reçues des API Google respecte la{" "}
          <a
            href="https://developers.google.com/terms/api-services-user-data-policy"
            target="_blank"
            rel="noreferrer"
            className="text-[#002FA7] hover:underline"
          >
            Google API Services User Data Policy
          </a>
          , y compris les exigences d'utilisation limitée (« Limited Use »).
        </p>
      </LegalSection>

      <LegalSection title="4. Comment nous utilisons vos données">
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Fournir, exploiter et améliorer les fonctionnalités de l'Application.</li>
          <li>Afficher vos statistiques de performance et vos audits SEO.</li>
          <li>Générer du contenu à votre demande via des fournisseurs d'IA (seuls les éléments nécessaires à la génération leur sont transmis).</li>
          <li>Assurer la sécurité du service et prévenir les abus.</li>
          <li>Vous contacter au sujet de votre compte lorsque nécessaire.</li>
        </ul>
        <p>Nous ne vendons ni ne louons vos données personnelles à des tiers.</p>
      </LegalSection>

      <LegalSection title="5. Stockage et sécurité">
        <p>
          Vos données sont stockées sur des serveurs sécurisés. Les mots de passe sont hachés et les jetons
          d'accès aux services tiers sont chiffrés. L'accès aux données est limité aux besoins de l'exploitation du
          service. Les communications entre votre navigateur et l'Application sont protégées par HTTPS.
        </p>
      </LegalSection>

      <LegalSection title="6. Durée de conservation">
        <p>
          Vos données sont conservées tant que votre compte est actif. En cas de suppression de votre compte ou sur
          demande, vos données personnelles sont supprimées dans un délai raisonnable, sauf obligation légale de
          conservation.
        </p>
      </LegalSection>

      <LegalSection title="7. Vos droits">
        <p>
          Conformément à la législation applicable en matière de protection des données (notamment la LPD suisse et le
          RGPD), vous disposez d'un droit d'accès, de rectification, de suppression et de portabilité de vos données,
          ainsi que d'un droit d'opposition au traitement. Pour exercer ces droits, contactez-nous à{" "}
          <a href="mailto:janou.info@gmail.com" className="text-[#002FA7] hover:underline">janou.info@gmail.com</a>.
        </p>
      </LegalSection>

      <LegalSection title="8. Cookies">
        <p>
          L'Application utilise uniquement les mécanismes de stockage strictement nécessaires à son fonctionnement
          (jeton de session pour maintenir votre connexion). Aucun cookie publicitaire ou de suivi tiers n'est utilisé.
        </p>
      </LegalSection>

      <LegalSection title="9. Modifications de cette politique">
        <p>
          Cette politique peut être mise à jour pour refléter l'évolution du service ou des obligations légales. La date
          de dernière mise à jour figure en haut de cette page. En cas de changement significatif, nous vous en
          informerons via l'Application.
        </p>
      </LegalSection>

      <LegalSection title="10. Contact">
        <p>
          Pour toute question relative à cette politique de confidentialité ou au traitement de vos données :{" "}
          <a href="mailto:janou.info@gmail.com" className="text-[#002FA7] hover:underline">janou.info@gmail.com</a>.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
